import React, {Component} from 'react';
import {ThemeContext} from '../../themeContext';
import { Headline4 } from '@material/react-typography';

class SurveezToolbar extends Component {

    // constructor(props) {
    //     super(props)
    //    // console.dir(props)

    // }

    render() {
      
        const theme = this.context.theme;

        let containerStyle = {
            background: theme.background,
            color: theme.color,
            borderBottom: `1px solid ${theme.background}`
        }
      return(
            <React.Fragment>
                <div className="app-toolbar" style={containerStyle}>
                    <Headline4 className="headline6">Surveez</Headline4>
                </div>
            </React.Fragment>
      )
    }
}

SurveezToolbar.contextType = ThemeContext;

export default SurveezToolbar;
